export default __webpack_public_path__ + "static/NNNittiGrotesk-TextBold-874c87e3508475fc7775d5fc68ef6556.eot";